import { render, staticRenderFns } from "./iron-partner-modal.vue?vue&type=template&id=24771cf4&"
import script from "./iron-partner-modal.vue?vue&type=script&lang=js&"
export * from "./iron-partner-modal.vue?vue&type=script&lang=js&"
import style0 from "./iron-partner-modal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/iron-partner-modal.vue
// module id = 1742
// module chunks = 0